<script setup lang="ts">
  import useIcons from '@/composables/useIcons'

  const { concordiaLogo, postbankLogo, dieBayerischeLogo, zurichLogo } = useIcons()

  interface Brand {
    icon: string
    alt: string
  }

  const brands: Brand[] = [
    { icon: concordiaLogo.value, alt: 'Concordia' },
    { icon: postbankLogo.value, alt: 'Postbank' },
    { icon: dieBayerischeLogo.value, alt: 'Die Bayerische' },
    { icon: zurichLogo.value, alt: 'Zurich' },
  ]
</script>

<template lang="pug">
.brand-bar
  h5.section-title {{ $t('ourGraduatesWorkFor') }}:
  .brand-images
    .brand-image-wrapper(v-for='(brand, index) in brands', :key='index')
      img(:src='brand.icon', :alt='brand.alt')
</template>

<style lang="postcss" scoped>
  .brand-bar {
    @apply ketch-w-full ketch-flex ketch-flex-col ketch-space-y-c10;
    @apply sm:ketch-flex-row sm:ketch-items-center sm:ketch-justify-between sm:ketch-space-x-c10 sm:ketch-space-y-0;

    .section-title {
      @apply ketch-font-bold;
    }

    .brand-images {
      @apply ketch-flex ketch-flex-wrap ketch-items-center ketch-gap-c10;
      @apply sm:ketch-flex-nowrap sm:ketch-justify-between sm:ketch-gap-c20;
    }

    .brand-image-wrapper {
      @apply ketch-transition-all ketch-duration-300 ketch-cursor-pointer ketch-flex-shrink-0;

      img {
        @apply ketch-w-[65px] ketch-h-auto xs1:ketch-w-[75px] sm:ketch-w-[85px] lg:ketch-w-[130px];
      }

      :deep(img) {
        @apply ketch-transition-all ketch-duration-300;
        filter: grayscale(100%);
      }

      &:hover {
        :deep(img) {
          filter: grayscale(0%);
        }
      }
    }
  }
</style>
